import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { OrderItemLabel } from "../project/style";
import { getImageContentFromType } from "./roomRendersService";

const CapturedImages = ({ isOpen, toggle, roomImages, rooms = [] }) => {

  // Collect all images from all rooms with room information
  const allImages = [];
  if (roomImages && typeof roomImages === "object") {
    Object.keys(roomImages).forEach((roomId) => {
      const room = rooms.find((r) => r.id.toString() === roomId.toString());
      const images = roomImages[roomId] || [];
      images.forEach((image) => {
        const imageContent = getImageContentFromType(image.image_type);
        allImages.push({
          ...image,
          roomId: roomId,
          roomName: room?.name || `Room ${roomId}`,
          hasMeasurements: image.image_type?.includes('internal') ,
          hasLabels: image.image_type?.includes('external') ,
        });
      });
    });
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} fullscreen>
      <ModalBody className="pt-0 ps-5">
        <div className="print-content">
          {allImages.length > 0 ? (
            allImages.map((image, index) => (
              <div
                key={index}
                className={`pe-3 position-relative ${index === 0 ? '' : 'pt-3'}`}
                style={{
                  width: "283mm",
                  height: "205mm",
                  pageBreakAfter: index < allImages.length - 1 ? "always" : "auto",
                  ...(index === 0 && { paddingTop: 0 }),
                }}
              >
                <div className="d-flex justify-content-between align-items-center border-bottom border-black p-3">
                  <div>
                    <p className="fs-5 fw-bold m-0">
                      {image.roomName}
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <span className="fs-6">Elevation A</span>
                    <span
                      className="bg-black rounded-circle"
                      style={{ width: "6px", height: "6px", display: "inline-block" }}
                    ></span>
                    <span className="fs-6">
                      {image.image_type?.includes('external') && image.image_type?.includes('internal')
                        ? 'External | Internal'
                        : image.image_type?.includes('external')
                        ? 'External'
                        : image.image_type?.includes('internal')
                        ? 'Internal'
                        : ''}
                    </span>
                    {image.hasMeasurements && (
                      <span className="fs-6">
                        <i className="fa-solid fa-check text-success me-1"></i>
                        Measurements
                      </span>
                    )}
                    {image.hasLabels && (
                      <span className="fs-6">
                        <i className="fa-solid fa-check text-success me-1"></i>
                        Labels
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className="d-flex my-3"
                  style={{ width: "100%", height: "85%" }}
                >
                  <div
                    className="position-relative d-flex justify-content-center align-items-center"
                    style={{ width: "100%" }}
                  >
                    <img
                      src={image.url || image.image_url}
                      alt={image.image_type || `Image ${index + 1}`}
                      style={{
                        maxWidth: "80%",
                        maxHeight: "80%",
                        objectFit: "contain",
                        display: "block",
                        cursor: "pointer",
                      }}
                      onClick={() => window.open(image.url || image.image_url, '_blank')}
                    />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-muted py-5">
              <p>No images to print</p>
            </div>
          )}
        </div>
        <style>{`
          @media print {
            body * {
              visibility: hidden;
            }
            .modal,
            .modal * {
              visibility: visible;
            }
            .modal {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              max-width: 100%;
              margin: 0;
              padding: 0;
            }
            .modal .modal-dialog {
              max-width: 100%;
              width: 100%;
              height: 100%;
              margin: 0;
            }
            .modal .modal-body {
              padding: 0 !important;
              max-height: none;
              overflow: visible;
              height: 100%;
            }
            .print-content {
              margin: 0;
              padding: 0;
            }
            .print-content > div:first-child {
              page-break-before: auto;
              margin-top: 0;
              padding-top: 0 !important;
            }
            .modal-body.pt-0.ps-5 {
              padding-left: 0 !important;
            }
            .print-page {
              page-break-after: always;
              page-break-inside: avoid;
              min-height: 100vh;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .print-page:last-child {
              page-break-after: auto;
            }
            .print-content img {
              max-width: 80%;
              max-height: 80%;
            }
          }
        `}</style>
      </ModalBody>
    </Modal>
  );
};

export default CapturedImages;

